
import { handleActions } from 'redux-actions';
import {
  FETCH_DETAIL_APPROVAL_REQUESTS,
  FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS,
  FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE,
} from './constants';

const initialState = {
  loading: false,
  hasError: false,
  error: null,
  approvalRequests: [],
};

export default handleActions({
  [FETCH_DETAIL_APPROVAL_REQUESTS]: state => ({
    ...state,
    error: '',
    hasError: false,
    loading: true,
  }),
  [FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS]: (state, { approvalRequests }) => ({
    ...state,
    approvalRequests,
    loading: false,
  }),
  [FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
    hasError: true,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/sites/approvalRequests/reducer.js